<ion-card class="card-common-blue ion-no-margin ion-margin-top">
  <!-- Card header with title and icon -->
  <ion-card-header>
    <ion-card-title>
      <div class="d-flex align-items-center gap-2">
        <ion-icon size="small" src="assets/imgs/garage.svg">
        </ion-icon>

        <span>
          {{ 'PREFERRED_WORKSHOPS' | translate }}
        </span>
      </div>
    </ion-card-title>
  </ion-card-header>

  <!-- Card content -->
  <ion-card-content class="ion-no-padding ion-margin-top">
    <ion-row>
      <!-- Preferred garage list -->
      @for (garages of primarygaragesInfo(); let i = $index; track $index) {
      <ion-item-divider class="bg-transparent garage-details" [ngClass]="{
            'border-0': i === primarygaragesInfo().length - 1,
            'ion-margin-top': i > 0
          }">
        <ion-col>
          <!-- Garage name -->
          <p class="garageName font-family-bold mb-1">
            {{ garages.vendoR_NAME }}
          </p>

          <!-- Garage address -->
          <p class="d-flex align-items-start gap-2 mb-2">
            <span>
              {{ garages.address }}<br />
              {{ garages.addresS2 || '-' }}<br />
              {{ garages.city }}<br />
              {{ garages.zip }}
            </span>
          </p>
        </ion-col>
      </ion-item-divider>
      }
    </ion-row>
  </ion-card-content>
</ion-card>